import { inject, Injectable } from "@angular/core";
import { FormStateProvider } from "@vp/formly/ui-schema-config";
import { ANON_CONFIG } from "@vp/shared/tokens";
import { of } from "rxjs";

@Injectable()
export class AnonymousFormStateProviderService implements FormStateProvider {
  readonly isAnonApi = !!inject(ANON_CONFIG);

  provide(_state: Record<string, unknown>) {
    return of({ isAnonymous: this.isAnonApi });
  }
}
